// extracted by mini-css-extract-plugin
module.exports = {"admin_verticals":"addverticals_admin_verticals__A_pAw"};